import React, { ReactNode } from 'react';

// Material ui
import { Typography as MaterialTypography } from '@material-ui/core';

// Variables
import VARIABLES from '@/assets/variables';

// Styles
import './Typography.scss';

export type TypographyVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'table-regular' | 'table-underline' | 'table-semibold' | 'input-head' | 'body-regular' | 'body-semibold' |'note-regular' | 'note-semibold' | 'steps';

export type TypographyColor = 'primary' | 'primary-dark' | 'secondary' | 'content' | 'content-light' | 'error' | 'success' | 'white' | 'background-light' | 'warning' | 'normal_green' | null;

interface Props {
    variant?: TypographyVariant;
    children: ReactNode;
    align?: 'inherit' | 'left' | 'center' | 'right' | 'justify' | undefined;
    noWrap?: boolean;
    color?: TypographyColor;
    className?: string;
    rootRef?: React.MutableRefObject<any>;
}

export const handleTypographyColor = (color: TypographyColor) => {
    switch (color) {
        case 'primary':
            return VARIABLES.palette.primary_color;
        case 'primary-dark':
            return VARIABLES.palette.primary_dark;
        case 'secondary':
            return VARIABLES.palette.secondary_color;
        case 'content-light':
            return VARIABLES.palette.content_light;
        case 'error':
            return VARIABLES.palette.error_color;
        case 'success':
            return VARIABLES.palette.success_color;
        case 'white':
            return 'white';
        case 'background-light':
            return VARIABLES.palette.background_light;
        case 'warning':
            return VARIABLES.palette.warning_color;
        case 'normal_green':
            return VARIABLES.palette.normal_green;
        default:
            return VARIABLES.palette.content_color;
    }
};

const Typography: React.FC<Props> = ({
    variant = 'body-regular',
    children,
    align = 'inherit',
    noWrap = false,
    color = 'content',
    className,
    rootRef
}) => {

    return (
        <>
            <MaterialTypography
                align={align}
                ref={rootRef}
                noWrap={noWrap}
                style={{ color: handleTypographyColor(color), whiteSpace: 'normal' }}
                className={`ui-Typography-component ${variant}-variant${className ? ` ${className}` : ''}`}
            >
                {children}
            </MaterialTypography>
        </>
    );
};

export default Typography;
